import * as React from "react";
import * as ReactDOM from "react-dom";
import { IOWidget, Options, Fun, Option, mk_widget, option } from "../widget";

export interface StateOptions<s> extends Options {
  mergeNewProps?:(currentState:s, propsState:s) => s,
  onKeyDown?:Fun<s,Fun<KeyboardEvent,Option<s>>>
}

export interface StatefulProps<s> {
  options?:StateOptions<s>
  input:s
  widget_s:IOWidget<s,s>
  on_done_s:(output_s:s) => void
}
export interface StatefulState<s> {
  value:s
}
export class Stateful<s> extends React.Component<StatefulProps<s>, StatefulState<s>> {
  constructor(props:StatefulProps<s>, context:any) {
    super(props, context)

    this.state = { value:props.input }
  }

  onKeyDown?:Fun<KeyboardEvent,any>
  registerKeyDown() {
    if (this.onKeyDown) window.removeEventListener("keydown", this.onKeyDown)
    if (this.props.options != undefined && this.props.options.onKeyDown != undefined) {
      const onKeyDown = this.props.options.onKeyDown
      this.onKeyDown = e => {
        let res = onKeyDown!(this.state.value)(e)
        if (res.v.kind == "r") {
          e.preventDefault()
          this.on_new_state(res.v.v)
          return false
        }
        return true
      }
      window.addEventListener("keydown", this.onKeyDown)
    }
  }

  componentDidMount() {
    this.registerKeyDown()
    this.on_new_state(this.state.value)
  }

  componentDidUpdate() {
    this.registerKeyDown()
  }

  componentWillUnmount() {
    if (this.onKeyDown) window.removeEventListener("keydown", this.onKeyDown)
  }

  on_new_state(new_s:s) {
    this.setState(s => ({...s, value:new_s}), () => this.props.on_done_s(new_s))
  }

  componentWillReceiveProps(nextProps:StatefulProps<s>) {
    // console.log("Receiving new props")
    if (this.props.options != undefined && this.props.options.mergeNewProps != undefined) {
      const mergeNewProps = this.props.options.mergeNewProps
      this.setState(s => ({...s, value:mergeNewProps(s.value, nextProps.input)}))
    }
  }

  render() {
    return <React.Fragment key={option("key", this.props.options)}>
        {this.props.widget_s(this.state.value).run(new_s => this.on_new_state(new_s))}
      </React.Fragment>
  }
}
export let stateful = function<s>(options?:StateOptions<s>) : (widget_s:IOWidget<s,s>) => IOWidget<s,s> {
  return widget_s => (input:s) => mk_widget({
    run:(on_done_s:(output:s) => void) =>
      React.createElement<StatefulProps<s>>(Stateful, { on_done_s, widget_s, input, options })
  })
}
